import SVImage from '@pkgs/shared-client/components/SVImage';
import SVPageMeta from '@apps/www/src/www/containers/SVPageMeta';
import SVRedirect from '@apps/www/src/www/containers/SVRedirect';
import useAuthTeam from '@apps/www/src/www/hooks/useAuthTeam';
import useIsLoggedIn from '@apps/www/src/www/hooks/useIsLoggedIn';
import SVNewTeamModal from '@apps/www/src/www/modals/SVNewTeamModal';
import SVBrands from '@pkgs/shared-client/components/SVBrands';
import SVButton, { SVButtonUSES } from '@pkgs/shared-client/components/SVButton';
import SVLandingPageFooter from '@pkgs/shared-client/components/SVLandingPageFooter';
import SVModal from '@pkgs/shared-client/components/SVModal';
import SVPageMargins from '@pkgs/shared-client/components/SVPageMargins';
import useEventCallback from '@pkgs/shared-client/hooks/useEventCallback';
import pickYourFavorites from '@pkgs/shared-client/img/teams/Final-3 1.png';
import comments from '@pkgs/shared-client/img/teams/Info exposed.png';
import avatarCloud from '@pkgs/shared-client/img/teams/avatar-cloud.png';
import feedMobile from '@pkgs/shared-client/img/upgrade/feed-mobile.png';
import feed from '@pkgs/shared-client/img/upgrade/feed.png';
import { useRouter } from 'next/router';

const SVTeamCreatePage = () => {
	const isLoggedIn = useIsLoggedIn();
	const team = useAuthTeam();
	const router = useRouter();

	const handleNewTeamClick = useEventCallback(() => {
		if (!isLoggedIn) {
			router.push(`/login/?next=${encodeURIComponent('/team/create/')}`);
			return;
		}

		SVModal.open(SVNewTeamModal);
	});

	if (team) {
		return <SVRedirect to="/team/users/" />;
	}

	const meta = {
		title: 'Team',
	};

	return (
		<>
			<SVPageMeta {...meta} />
			<div className="flex flex-col w-full max-w-full overflow-hidden">
				<div className="flex flex-col items-center px-6 py-16">
					<div className="font-semibold text-center type-title">Create your team</div>
					<div className="mt-6 text-center text-gray-500 type-subnav">
						Add team members to one plan and have an exclusive feed.
					</div>
					<SVButton
						use={SVButtonUSES.PRIMARY}
						className="mt-16 w-fit"
						onClick={handleNewTeamClick}
					>
						Create your team
					</SVButton>
					<div className="w-4/5">
						<picture>
							<source srcSet={feed} media="(min-width: 1024px)" />
							<SVImage
								alt="teams feed"
								src={feedMobile}
								className="w-full mt-20"
							/>
						</picture>
					</div>
				</div>
				<div className="pb-20">
					<SVPageMargins className="flex flex-col items-center">
						<div className="mt-8 font-semibold text-center type-title text-primary">
							Exclusive team feed
						</div>
						<div className="mt-6 text-center text-gray-500 type-pagenav">
							Have a feed of inspiration curated by members of your team.
						</div>
						<div className="relative mt-12">
							<SVImage
								src={avatarCloud}
								className="relative z-20 w-full"
								alt="avatar cloud"
							/>
							<div
								className={`absolute top-[calc(50%-9.8vw)] z-10 w-full text-center text-[13.8vw] font-semibold text-gray-800`}
							>
								Your&nbsp;&nbsp;&nbsp;Team
							</div>
						</div>
					</SVPageMargins>
				</div>
				<SVPageMargins>
					<div className="flex justify-between mt-24 -sm:flex-col -sm:mt-10 max-w-screen-2xl mx-auto">
						<div className="flex flex-col items-center justify-center flex-1">
							<div className="-sm:mb-14 flex max-w-[282px] flex-col">
								<div className="font-semibold text-gray-300 -sm:text-centertype-title type-title">
									Add comments
								</div>
								<div className="mt-6 text-gray-400 -sm:text-center type-pagenav text-opacity-60">
									Provide feedback on saves you
									<br />
									like by leaving your comment
								</div>
								<SVButton
									use={SVButtonUSES.DEFAULT}
									isDisabled={true}
									className="-sm:self-center mt-14 w-fit"
								>
									Soon
								</SVButton>
							</div>
						</div>
						<div>
							<SVImage
								src={comments}
								className="-sm:w-full -lg:mr-0 mr-36 w-[47.5vw] max-w-[684px]"
								alt="comments frame"
							/>
						</div>
					</div>
					<div className="flex justify-between mt-28 max-w-screen-2xl mx-auto">
						<div className="-sm:flex-1">
							<SVImage
								src={pickYourFavorites}
								className="-sm:w-full -sm:object-right-bottom -sm:h-full -sm:object-cover  -md:ml-32 -sm:ml-0 ml-52 w-[25.6vw]"
								alt="inspiration"
							/>
						</div>
						<div
							className="-sm:flex-[2] -sm:px-3 flex flex-1 flex-col items-center justify-center"
						>
							<div className="flex flex-col">
								<div className="font-semibold text-gray-300 type-title">
									Pick your
									<br />
									Favorites
								</div>
								<div className="mt-6 text-gray-400 type-pagenav text-opacity-60">
									Have a feed of inspiration curated
									<br />
									by members of your team.
								</div>
								<SVButton
									use={SVButtonUSES.DEFAULT}
									isDisabled={true}
									className="mt-14 w-fit"
								>
									Soon
								</SVButton>
							</div>
						</div>
					</div>
				</SVPageMargins>
				<SVBrands />
				<SVPageMargins>
					<div className="flex items-center">
						<SVButton
							onClick={handleNewTeamClick}
							use={SVButtonUSES.PRIMARY}
							className="m-auto w-full max-w-[320px]"
						>
							Create your team
						</SVButton>
					</div>
					<SVLandingPageFooter className="mt-40" />
				</SVPageMargins>
			</div>
		</>
	);
};

export default SVTeamCreatePage;
